<template>
  <section :class="['grid-works']">
    <sui-grid :columns="1">
      <sui-grid-row>
        <sui-grid-column>
          <transition-group
            name="staggered"
            :css="false"
            @before-enter="beforeEnter"
            @enter="enter"
            @leave="leave"
            tag="div"
            class="grid-works__container"
            v-if="itemJobs.length !== 0 && !fetching"
          >
            <div
              v-for="(item, index) in itemJobs"
              :key="`${item.title}-${index}`"
              :data-index="index"
              :style="{ background: getBg(item.image) }"
              :class="[`item-${index}`, 'grid-works__item']"
              v-show="showItems"
            >
              <router-link
                :key="`${item.title}-${index}`"
                :to="`/works/${$i18n.locale}/${item.slug}`"
              >
                <div
                  :data-index="index"
                  :key="`${item.title}-${index}`"
                  class="grid-works__item__overlay"
                >
                  <div class="grid-works__item__overlay__header">
                    <h2>{{ item.title }}</h2>
                    <div class="grid-works__item__overlay__header__tags">
                      <ul>
                        <li>{{ item.client }}</li>
                        <span class="grid-works__item__overlay__header__tags--separator">, </span>
                        <li>{{ item.year }}</li>
                        <span class="grid-works__item__overlay__header__tags--separator">, </span>
                        <li>{{ item.regional_name }}</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </router-link>
            </div>
          </transition-group>

          <h3 class="grid-works--no-results" v-if="itemJobs.length === 0 && !fetching">
            {{ errorMessage ? errorMessage : $t("generals.jobsfounded") }}
          </h3>
          <sui-loader v-show="fetching" size="large" active centered inline />
        </sui-grid-column>
      </sui-grid-row>
    </sui-grid>
  </section>
</template>

<script>
import Velocity from "velocity-animate";

export default {
  name: "grid-works",
  props: {
    jobs: {
      type: Array,
    },

    fetching: {
      type: Boolean,
      default: true,
    },

    animate: {
      type: Boolean,
      default: true,
    },

    errorMessage: {
      type: [String, null],
      default: null,
    },
  },

  data() {
    return {
      showItems: true,
    };
  },

  computed: {
    itemJobs() {
      return this.jobs || [];
    },
  },

  watch: {
    animate(bool) {
      this.showItems = false;

      setTimeout(() => {
        this.showItems = bool;
      }, 300);
    },
  },

  methods: {
    getBg(image) {
      return `url(${image}) no-repeat center center`;
    },

    beforeEnter(el) {
      const $el = el;
      $el.style.opacity = 0;
    },

    enter(el, done) {
      const delay = el.dataset.index * 150;
      setTimeout(() => {
        Velocity(el, { opacity: 1 }, { complete: done });
      }, delay);
    },

    leave(el, done) {
      const delay = el.dataset.index * 5;

      setTimeout(() => {
        Velocity(el, { opacity: 0 }, { complete: done });
      }, delay);
    },
  },
};
</script>

<style lang="scss">
@import "./styles/grid-works";
</style>
